import { Navigate } from 'react-router';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_MARKET,
  ANY_SPORT_MARKET_WHEEL_RARITY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useSimplifiedNav } from '@sorare/core/src/hooks/commonGame/useSimplifiedNav';
import { useEnabledWheelByRarity } from '@sorare/core/src/hooks/useEnabledWheelByRarity';

export const MarketWheelPage = () => {
  const enabledWheelByRarity = useEnabledWheelByRarity();
  const { sport, generateSportContextPath } = useSportContext();
  const { showSimplifiedNav } = useSimplifiedNav(sport);

  if (!enabledWheelByRarity.limited && !enabledWheelByRarity.common) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_MARKET)} replace />;
  }

  let defaultRarity: string | null = null;
  if (enabledWheelByRarity.limited && !showSimplifiedNav) {
    defaultRarity = Rarity.limited;
  } else if (enabledWheelByRarity.common) {
    defaultRarity = Rarity.common;
  }

  if (!defaultRarity) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_MARKET)} replace />;
  }

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MARKET_WHEEL_RARITY, {
        params: {
          rarity: defaultRarity,
        },
      })}
      replace
    />
  );
};

export default MarketWheelPage;
